import { Z_INDEX_OVERLAY_SEARCH } from '../../../constants/z_index';
export const getBannerStyle = () => ({
  height: '0',
  width: '100%',
  zIndex: Z_INDEX_OVERLAY_SEARCH
});
export const getFloatingStyle = () => ({
  zIndex: Z_INDEX_OVERLAY_SEARCH,
  position: 'absolute',
  top: 'var(--global-nav-height)',
  left: '50%',
  transform: 'translateX(-50%)',
  height: 0,
  width: 0
});
export const getTeaseStyle = () => ({
  zIndex: Z_INDEX_OVERLAY_SEARCH,
  position: 'absolute',
  top: '20px',
  right: '15px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: 0,
  width: 0
});
export const getSidebarStyle = () => ({
  position: 'fixed',
  display: 'flex',
  flexDirection: 'column',
  top: 0,
  right: 0,
  zIndex: Z_INDEX_OVERLAY_SEARCH,
  width: 0,
  height: '100%'
});